import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import arrowIconUp from '../../assets/images/dropdown-up.svg';
import arrowIconDown from '../../assets/images/dropdown-down.svg';
import css from './rank-dropdown.scss';
import studentCertificatesGemCountActions from '../../containers/certificates/student-certificates-gem-count-actions';

class RankDropdown extends Component {
    static propTypes = {
        certificatesCount: PropTypes.number.isRequired,
        retrievedGems: PropTypes.array,
        localeData: PropTypes.object,
        downloadCertificatesByGem: PropTypes.func
    };

    constructor(props) {
        super(props);
        const { retrievedGems, certificatesCount, localeData } = props;
        this.state = {
            dropdownTriggered: false,
            show: false,
            isAllSelected: true,
            selectedOptions: retrievedGems.map(() => true),
            title: localeData['Label - All'],
            downloadCount: certificatesCount
        };
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }

    handleOutsideClick = (event) => {
        if (
            this.dropdownRef &&
            this.dropdownRef.contains &&
            !this.dropdownRef.contains(event.target)
        ) {
            if (this.state.show && !this.state.dropdownTriggered) {
                this.setState({ show: false });
                event.stopPropagation();
            }
            this.setState({
                dropdownTriggered: false
            });
        }
    };

    handleToggle = () => {
        const toggleState = !this.state.show;
        this.setState({
            show: toggleState,
            dropdownTriggered: toggleState
        });
    };

    getButtonText = () => (
        <div key="rank-button" title={this.state.title}>
            {this.state.title} ({this.state.downloadCount})
        </div>
    );

    toggleSelectAll = () => {
        const updatedSelect = !this.state.isAllSelected;
        this.setState({
            isAllSelected: updatedSelect
        });

        if (updatedSelect) {
            this.setState({
                selectedOptions: this.props.retrievedGems.map(() => true),
                downloadCount: this.props.certificatesCount
            });
        } else {
            this.setState({
                selectedOptions: this.props.retrievedGems.map(() => false),
                downloadCount: 0
            });
        }

        const result = '';

        this.setState({
            title: this.props.localeData['Label - All']
        });

        const resultCount = updatedSelect ? this.props.certificatesCount : 0;
        this.props.downloadCertificatesByGem({
            payload: {
                selectedGems: { result, resultCount }
            }
        });
    };

   convertToRoman = (num) => {
       if (num === 16) {
           return '∞';
       }
       const numberArr = [10, 9, 5, 4, 1];
       const RomanArr = ['X', 'IX', 'V', 'IV', 'I'];
       const result = [];

       const findElement = e => e <= num;

       while (num > 0) {
           const nextHighest = numberArr.find(findElement);

           if (nextHighest) {
               result.push(RomanArr[numberArr.indexOf(nextHighest)]);
               num -= nextHighest;
           }
       }
       return result.join('');
   };

    selectOption = (isChecked, index) => {
        const { selectedOptions } = this.state;
        const { retrievedGems } = this.props;

        // Update the selected options
        const updatedOptions = [
            ...selectedOptions.slice(0, index),
            isChecked,
            ...selectedOptions.slice(index + 1)
        ];

        // Determine if all options are selected
        const isAllSelected = isChecked ? updatedOptions.every(value => value) : false;

        // Filter the selected gems
        const selectedGems = updatedOptions
            .map((value, selectedIndex) => (value ? selectedIndex : -1))
            .filter(selectedIndex => selectedIndex !== -1);

        // Filter the retrieved gems based on updated options
        const newArray = retrievedGems.filter((_, optIndex) => updatedOptions[optIndex]);

        this.setState({
            selectedOptions: updatedOptions,
            isAllSelected,
            downloadCount: newArray.reduce((acc, item) => acc + item.count, 0),
            title: isAllSelected ? this.props.localeData['Label - All'] :
                newArray.map(item => this.convertToRoman(item.gem)).join(', ')
        });

        // Prepare the result string and set it in store
        const result = selectedGems
            .map(gemType => `gemTypes: ${gemType + 1}`)
            .join(', ');

        const resultCount = newArray.reduce((acc, item) => acc + item.count, 0);
        this.props.downloadCertificatesByGem({
            payload: {
                selectedGems: { result, resultCount }
            }
        });
    }

    render() {
        const { localeData } = this.props;

        return (
            <div className={css['dropdown-container']}>
                <div
                    role="button"
                    className={css['dropdown-trigger']}
                    tabIndex={0}
                    onClick={this.handleToggle}
                >
                    {this.getButtonText()}
                    <Isvg src={this.state.show ? arrowIconUp : arrowIconDown} />
                </div>

                {this.state.show && (
                    <div ref={(node) => { this.dropdownRef = node; }} className={css['dropdown-options-container']}>
                        <div className={css['dropdown-option']}>
                            <div>
                                <input
                                    className={css['check-box']}
                                    id={'All'}
                                    name={'All'}
                                    type="checkbox"
                                    checked={this.state.isAllSelected}
                                    onChange={() => this.toggleSelectAll()}
                                />
                                <label htmlFor={'All'}>{localeData['Label - All']}</label>
                            </div>
                            <div>{this.props.certificatesCount}</div>
                        </div>
                        {this.props.retrievedGems.map((option, index) => (
                            <div
                                className={css['dropdown-option']}
                                key={option.gem}
                            >
                                <div>
                                    <input
                                        className={css['check-box']}
                                        id={option.gem}
                                        name={option.gem}
                                        type="checkbox"
                                        checked={this.state.selectedOptions[option.gem - 1]}
                                        disabled={option.count === 0}
                                        onChange={e =>
                                            this.selectOption(e.target.checked, index)
                                        }
                                    />
                                    <label htmlFor={option.gem}>
                                        {this.convertToRoman(option.gem)}
                                    </label>
                                </div>
                                <div>{option.count}</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        studentCertificatesGemCount: state.studentCertificatesGemCount
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentCertificatesGemCount: studentCertificatesGemCountActions.getStudentCertificatesGemCount,
        downloadCertificatesByGem: studentCertificatesGemCountActions.downloadCertificatesByGem
    }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(styleable(css)(RankDropdown));



// WEBPACK FOOTER //
// ./components/rank-dropdown/rank-dropdown.js